/* Verlane Home - Custom PDP behaviour
 * No Liquid here. Each section renders a
 * <script type="application/json" data-vh-config> block that this reads.
 *
 * Config uses short keys and pre-sized image URLs to keep the inline JSON
 * small: o1/o2/o3 = option values, p = price in cents, c = compare-at,
 * img = ready-to-use url. Liquid already sized those, so they do NOT go
 * through sizedUrl(). Only the recommendations API returns raw urls.
 *
 * Bundle: qty 1 = full price (no code), qty 2+ = VERLANE10.
 */
(function () {
  'use strict';

  var DISCOUNT_CODES = { 1: null, 2: 'VERLANE10' };
  var TIER_2_PCT = 0.10;
  var SHIP_BUSINESS_DAYS = 3;

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  // Only for urls we did not size in Liquid (recommendations API).
  // Shopify urls end in ?v=123, so the extension is not at the end.
  function sizedUrl(url, w) {
    if (!url) return '';
    var parts = String(url).split('?');
    var base = parts[0];
    var query = parts[1] ? '?' + parts[1] : '';
    base = base.replace(/\.(jpg|jpeg|png|webp|gif|avif)$/i, '_' + w + 'x.$1');
    return base + query;
  }

  function bareUrl(url) {
    return String(url || '').split('?')[0];
  }

  function addBusinessDays(from, n) {
    var date = new Date(from);
    var added = 0;
    while (added < n) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }

  function initPdp(cfg) {
    var sid = cfg.sectionId;
    var root = document.getElementById('vh-pdp-' + sid);
    if (!root) return;

    var variants = cfg.variants || [];
    var images = cfg.images || [];

    var state = {
      qty: 1,
      tier: 1,
      variantId: cfg.variantId,
      price: cfg.price
    };

    var selectedOptions = {};
    (cfg.selected || []).forEach(function (val, i) {
      if (val !== null && val !== undefined) selectedOptions[i + 1] = val;
    });

    var el = function (id) { return document.getElementById(id + '-' + sid); };

    var shipEl = el('vh-ship-date');
    if (shipEl) {
      shipEl.textContent = addBusinessDays(new Date(), SHIP_BUSINESS_DAYS)
        .toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    function updatePrice() {
      var priceEl = el('vh-price');
      var atcPriceEl = el('vh-atc-price');
      var noteEl = el('vh-discount-note');
      var total = state.price * state.qty;

      if (priceEl) priceEl.textContent = money(state.price);
      if (atcPriceEl) atcPriceEl.textContent = money(total);

      if (noteEl) {
        if (state.tier === 2) {
          noteEl.textContent = '10% off applied at checkout: ' + money(total * (1 - TIER_2_PCT));
        } else {
          noteEl.textContent = 'Add one more and save ' +
            money(state.price * 2 * TIER_2_PCT) + ' at checkout';
        }
      }
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = [v.o1, v.o2, v.o3];
        var match = true;
        for (var key in selectedOptions) {
          if (!Object.prototype.hasOwnProperty.call(selectedOptions, key)) continue;
          if (opts[parseInt(key, 10) - 1] !== selectedOptions[key]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // 1) the variant's own image
    // 2) any variant sharing o1 (usually colour) that has one
    // 3) give up and leave the current image alone
    function resolveVariantImage(v) {
      if (v.img) return v.img;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].o1 === v.o1 && variants[i].img) return variants[i].img;
      }
      return '';
    }

    function setMainImage(src) {
      if (!src) return;
      var mainImg = el('vh-main-img');
      if (!mainImg) return;
      mainImg.src = src; // already sized by Liquid

      var target = bareUrl(src);
      var thumbs = root.querySelectorAll('.vh-thumb');
      for (var i = 0; i < thumbs.length; i++) {
        var idx = parseInt(thumbs[i].dataset.idx, 10);
        var candidate = bareUrl(images[idx]);
        thumbs[i].classList.toggle('active', !!candidate && candidate === target);
      }
    }

    // Single path used by BOTH swatches and pills.
    function updateVariant() {
      var v = findVariant();
      if (!v) return;

      state.variantId = v.id;
      state.price = v.p;

      setMainImage(resolveVariantImage(v));

      var compareEl = el('vh-compare');
      var badgeEl = el('vh-badge');
      if (compareEl) {
        if (v.c && v.c > v.p) {
          compareEl.textContent = money(v.c);
          compareEl.style.display = '';
          if (badgeEl) {
            badgeEl.textContent = 'Save ' + money(v.c - v.p);
            badgeEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* non-critical */ }

      updatePrice();
    }

    function setTierUI(tierNum) {
      state.tier = tierNum;
      var tiers = root.querySelectorAll('.vh-tier');
      for (var i = 0; i < tiers.length; i++) {
        tiers[i].classList.toggle('active', tiers[i].dataset.tier === String(tierNum));
      }
    }

    function setQtyUI() {
      var qtyEl = el('vh-qty');
      if (qtyEl) qtyEl.textContent = state.qty;
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var thumb = t.closest('.vh-thumb');
      if (thumb) {
        setMainImage(images[parseInt(thumb.dataset.idx, 10)]);
        return;
      }

      var swatch = t.closest('.vh-swatch');
      if (swatch) {
        var sIdx = swatch.dataset.optIdx;
        var sVal = swatch.dataset.value;
        selectedOptions[sIdx] = sVal;

        var sLbl = document.getElementById('vh-opt-label-' + sIdx + '-' + sid);
        if (sLbl) sLbl.textContent = sVal;

        var sWrap = swatch.closest('.vh-swatches');
        if (sWrap) {
          sWrap.querySelectorAll('.vh-swatch').forEach(function (b) {
            var on = b.dataset.value === sVal;
            b.classList.toggle('active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
        updateVariant();
        return;
      }

      var pill = t.closest('.vh-pill');
      if (pill) {
        var pIdx = pill.dataset.optIdx;
        var pVal = pill.dataset.value;
        selectedOptions[pIdx] = pVal;

        var pLbl = document.getElementById('vh-opt-label-' + pIdx + '-' + sid);
        if (pLbl) pLbl.textContent = pVal;

        var pWrap = pill.closest('.vh-option-pills');
        if (pWrap) {
          pWrap.querySelectorAll('.vh-pill').forEach(function (b) {
            b.classList.toggle('active', b.dataset.value === pVal);
          });
        }
        updateVariant();
        return;
      }

      var tier = t.closest('.vh-tier');
      if (tier) {
        var tierNum = parseInt(tier.dataset.tier, 10);
        if (tierNum === 2) state.qty = Math.max(state.qty, 2);
        else if (state.qty > 1) state.qty = 1;
        setTierUI(tierNum);
        setQtyUI();
        updatePrice();
        return;
      }

      if (t.closest('#vh-qty-minus-' + sid)) {
        if (state.qty > 1) {
          state.qty--;
          if (state.qty < 2) setTierUI(1);
          setQtyUI();
          updatePrice();
        }
        return;
      }

      if (t.closest('#vh-qty-plus-' + sid)) {
        state.qty++;
        if (state.qty >= 2) setTierUI(2);
        setQtyUI();
        updatePrice();
        return;
      }

      if (t.closest('#vh-atc-' + sid)) {
        var btn = el('vh-atc');
        if (!btn || btn.disabled) return;
        var labelEl = btn.querySelector('.vh-atc-label');
        var origLabel = labelEl ? labelEl.textContent : 'Add to Cart';

        btn.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: state.variantId, quantity: state.qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            var code = DISCOUNT_CODES[state.tier];
            if (!code) return null; // tier 1 is full price
            return fetch('/discount/' + code, { method: 'GET' });
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.disabled = false;
            if (labelEl) labelEl.textContent = origLabel;
            window.alert('Something went wrong adding this to your cart. Please try again.');
          });
        return;
      }
    });

    // ---------- Complete the Space ----------
    var crossWrap = el('vh-cross');
    var crossGrid = el('vh-cross-grid');
    var crossLoaded = false;
    var limit = cfg.crossLimit || 4;

    // Normalises both shapes: our fallback entries use short keys and a
    // pre-sized img; the recommendations API returns title/url/price and a
    // raw featured_image string that still needs sizing.
    function normalise(p) {
      if (p.t !== undefined) {
        return { title: p.t, url: p.u, price: p.p, img: p.img };
      }
      var raw = p.featured_image;
      if (raw && typeof raw !== 'string') raw = raw.src;
      return {
        title: p.title,
        url: p.url,
        price: p.price,
        img: raw ? sizedUrl(raw, 600) : ''
      };
    }

    function renderCross(list) {
      if (!crossWrap || !crossGrid) return;
      if (!list || !list.length) return;

      var picked = list.slice(0, limit).map(normalise);
      var html = '';

      picked.forEach(function (p) {
        var imgHtml = p.img
          ? '<img src="' + p.img + '" alt="" loading="lazy" width="600" height="600">'
          : '<div class="vh-cross-placeholder">No image</div>';

        html += '<a class="vh-cross-card" href="' + encodeURI(p.url) + '">' +
                  '<div class="vh-cross-img">' + imgHtml + '</div>' +
                  '<p class="vh-cross-name"></p>' +
                  '<p class="vh-cross-price">' + money(p.price) + '</p>' +
                '</a>';
      });

      crossGrid.innerHTML = html;

      // Titles via textContent so a product name can never inject markup
      var names = crossGrid.querySelectorAll('.vh-cross-name');
      picked.forEach(function (p, i) {
        if (names[i]) names[i].textContent = p.title;
      });

      crossWrap.hidden = false;
      crossWrap.removeAttribute('hidden');
    }

    function loadCross() {
      if (crossLoaded || !crossWrap || !crossGrid) return;
      crossLoaded = true;

      var fallback = cfg.fallback || [];

      fetch('/recommendations/products.json?product_id=' + cfg.productId +
            '&limit=' + limit + '&intent=related')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          // Shopify's related-products index can be empty on a young store,
          // so fall back to the product's own collection.
          var items = (data && data.products && data.products.length)
            ? data.products
            : fallback;
          renderCross(items);
        })
        .catch(function () { renderCross(fallback); });
    }

    // Load when the browser goes idle.
    //
    // Do NOT hang an IntersectionObserver on crossWrap itself: it starts
    // with [hidden], so it has display:none and no layout box, and can
    // never report as intersecting. The observer would wait forever for an
    // element waiting on the observer. Card images are loading="lazy"
    // anyway, so deferring the whole section bought almost nothing.
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadCross, { timeout: 2000 });
    } else {
      window.setTimeout(loadCross, 500);
    }

    updatePrice();
  }

  function boot() {
    var blocks = document.querySelectorAll('script[type="application/json"][data-vh-config]');
    for (var i = 0; i < blocks.length; i++) {
      try {
        initPdp(JSON.parse(blocks[i].textContent));
      } catch (err) {
        if (window.console) console.warn('[verlane-pdp] bad config block', err);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
